import { IBlogArticle } from '@/api/types/blog';
import { useReporting } from '@/hooks/useReporting';
import useRouteInfo from '@/hooks/useRouteInfo';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { useCallback, useEffect, useRef } from 'react';

export const useBlogAuthorDetailTrack = () => {
  const { trackEvent } = useReporting();
  const enterTimer = useRef<number>(Date.now());
  const { getFromRouterInfo } = useRouteInfo();
  const pageView = useCallback(() => {
    const { refer_page_name, refer_url_path } = getFromRouterInfo();
    trackEvent(
      {
        eventName: 'BlogAuthorDetailsPage_View',
        properties: {
          refer_page_name,
          refer_url_path,
        },
      },
      [ProviderType.SENSORS],
    );
  }, []);

  const getArticleSensor = useCallback((article: IBlogArticle, index: number) => {
    return {
      article_name: article.name,
      article_index: index,
      article_category: article.type,
      author_name: article.blog_author_name,
    };
  }, []);

  const sdBlogAuthorDetailsPageArticleExp = useCallback((article: IBlogArticle, index: number) => {
    try {
      const sdEventName = 'BlogAuthorDetailsPageArticle_Exp';
      const sdEventParams = getArticleSensor(article, index);
      trackEvent(
        {
          eventName: sdEventName,
          properties: sdEventParams,
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.log(e);
    }
  }, []);

  const sdBlogAuthorDetailsPageArticleClick = useCallback(
    (article: IBlogArticle, index: number) => {
      try {
        const sdEventName = 'BlogAuthorDetailsPageArticle_Click';
        const sdEventParams = getArticleSensor(article, index);
        trackEvent(
          {
            eventName: sdEventName,
            properties: sdEventParams,
          },
          [ProviderType.SENSORS],
        );
      } catch (e) {
        logger.log(e);
      }
    },
    [],
  );

  useEffect(() => {
    enterTimer.current = Date.now();
    pageView();
  }, []);

  return {
    pageView,
    sdBlogAuthorDetailsPageArticleExp,
    sdBlogAuthorDetailsPageArticleClick,
  };
};
